
import styled from 'styled-components';
import { Box } from '@/shared/ui/box/Box';

const BonusConditionsCard = styled(Box)`
  padding: 20px;
  background: #27262B;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const StepsList = styled.ol`
  margin: 0;
  padding-left: 24px;
  list-style-type: decimal;
  color: #AFAFAF;
`;

const WhiteText = styled.span`
  color: #FFF;
`;

export {BonusConditionsCard,StepsList,WhiteText}